import {
  Button,
  List,
  ListItem,
  Paragraph,
  SectionTitle,
} from "../components/typography.jsx";
import { Col, Row } from "../components/layout.jsx";
import {
  Headline,
  ImageHeader,
  MainContent,
  PanelInfos,
  Section,
  TwoColumns,
} from "../templates/common/Components.jsx";
import Pagination, { usePagination } from "../components/Pagination.jsx";
import { color, styled } from "../util/style.js";

import Container from "../templates/common/Container.jsx";
import ContentLoading from "../components/ContentLoading.jsx";
import LoggedInTemplate from "../templates/LoggedInTemplate.jsx";
import MyProshopVoucherItem from "../components/MyProshopVoucherItem.jsx";
import header from "../img/services_bandeau.jpg";
import header2x from "../img/services_bandeau@2x.jpg";
import headerMobile from "../img/services_bandeau_mobile.jpg";
import headerMobile2x from "../img/services_bandeau_mobile@2x.jpg";
import { paths } from "../services/router.js";
import { useMyProshopVouchers } from "../services/myProshopVouchers.js";
import { useRef } from "react";

const DEFAULT_LIMIT = 10;

const MyProshopVouchersList = styled.div`
  ${MyProshopVoucherItem} + ${MyProshopVoucherItem} {
    margin-top: 30px;
  }
`;

const PanelAlert = styled.div`
  color: ${color("primary")};
  font-weight: bold;
`;

export default function MyProshopVouchers() {
  const topScroll = useRef();

  const pagination = usePagination(DEFAULT_LIMIT, topScroll.current);
  const [myProshopVouchersResult, { ready, loading }] =
    useMyProshopVouchers(pagination);

  const myProshopVouchers = (myProshopVouchersResult?.edges || []).map(
    ({ node }) => node,
  );

  const voucherRatio = 1.25;

  return (
    <LoggedInTemplate title="Bons My Proshop">
      <ImageHeader
        image={header}
        image2x={header2x}
        imageMobile={headerMobile}
        imageMobile2x={headerMobile2x}
        icon="hands-line"
        label="Bons My Proshop"
      />
      <MainContent>
        <Headline title="Bons My Proshop">
          Et si votre cagnotte cadeaux vous permettait aussi de payer votre
          matériel Daikin ?
        </Headline>

        <Container>
          <TwoColumns
            aside={
              <PanelInfos
                label={`Commandez vos bons My Proshop directement sur ELITE`}
              >
                <p style={{ textAlign: "center" }}>
                  <Button to={paths.myProshopVoucherCreate}>Je commande</Button>
                </p>
              </PanelInfos>
            }
          >
            <SectionTitle>Comment ça marche ?</SectionTitle>
            <Paragraph>
              Pour convertir vos budgets cadeaux en bons d'achat My Proshop :
            </Paragraph>
            <List ordered>
              <ListItem>Commandez un ou plusieurs bons My Proshop</ListItem>
              <ListItem>
                Les montants sont déduits directement de votre budget cadeaux
              </ListItem>
              <ListItem>Profitez de vos bons sur le site My Proshop</ListItem>
            </List>
            <Paragraph>
              <strong> Attention !</strong>
              <br />
              Les bons ne sont pas cumulables sur la même commande.
            </Paragraph>
            <PanelAlert>
              Vous bénéficiez d'une bonification de 25% sur la valeur des bons !
            </PanelAlert>
          </TwoColumns>
        </Container>

        <Section>
          <Container>
            <Headline title="Mes commandes - Bons My Proshop"></Headline>
            <span ref={topScroll} />
            {loading ? (
              <ContentLoading />
            ) : myProshopVouchers.length > 0 ? (
              <>
                <MyProshopVouchersList>
                  {myProshopVouchers.map((voucher, index) => (
                    <MyProshopVoucherItem
                      {...voucher}
                      shopAmount={
                        voucher.amount *
                        (+new Date(voucher.expirationDate) >
                        +new Date(2026, 1, 1, 0, 0, 0) // Seulement pour les bons après 2026
                          ? voucherRatio
                          : 1)
                      }
                      key={voucher.id}
                      index={index + 1}
                    />
                  ))}
                </MyProshopVouchersList>
                {Boolean(ready && myProshopVouchers?.length) && (
                  <Pagination
                    result={myProshopVouchersResult}
                    pagination={pagination}
                  />
                )}
              </>
            ) : (
              <Paragraph style={{ textAlign: "center" }}>
                Aucun bon n'a été commandé
              </Paragraph>
            )}
          </Container>
        </Section>
      </MainContent>
    </LoggedInTemplate>
  );
}
